import { Component, Output, EventEmitter } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ValidatePasswordFPO } from '../../validators/password.fpo.validator';

/**
 * ChangePasswordFormComponent
 */
@Component({
  selector: 'ecp-change-password-form',
  templateUrl: './change-password-form.component.html',
  styleUrls: ['./change-password-form.component.scss'],
  standalone: false,
})
export class ChangePasswordFormComponent {
  /**
   * submit
   * @type {EventEmitter<any>}
   */
  @Output() submitChangePassword: EventEmitter<any> = new EventEmitter();
  /**
   * form
   * @type {FormGroup}
   */
  public form: UntypedFormGroup = new UntypedFormGroup({
    password: new UntypedFormControl('', {
      validators: Validators.compose([Validators.required, ValidatePasswordFPO]),
    }),

    passwordConfirm: new UntypedFormControl('', {
      validators: Validators.compose([Validators.required]),
    }),
  });

  /**
   * password
   * @returns {AbstractControl}
   */
  public get password(): AbstractControl {
    return this.form.get('password');
  }

  /**
   * passwordConfirm
   * @returns {AbstractControl}
   */
  get passwordConfirm(): AbstractControl {
    return this.form.get('passwordConfirm');
  }

  /**
   * handleSubmit
   * @param event
   */
  handleSubmit(event): void {
    this.submitChangePassword.emit(event);
  }
}
